import React from 'react';
import { LoadingOutlined } from '@ant-design/icons';
import { Spin } from 'antd';
const antIcon = <LoadingOutlined style={{ fontSize: 24 }} spin />;
const EventLoader: React.FC = () => <Spin indicator={antIcon} className='modal-loader event absolute top-0 left-0' />;
export default EventLoader
